import { FC, PropsWithChildren } from 'react';

import { Popover, TextLink } from '@eneco/sparky';
import { useMediaQuery } from '@eneco/sparky/hooks';
import { InfoIcon } from '@eneco/sparky/icons';
import { styled } from '@eneco/sparky/stitches';
import { TextLinkProps } from '@eneco/sparky/types';

interface InfoComponentProps extends PropsWithChildren {
  title?: string;
  triggerText: string;
  variant?: 'icon' | 'text';
  emphasis?: TextLinkProps['emphasis'];
}

const StyledButton = styled('button', {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
});

const InfoComponent: FC<InfoComponentProps> = ({ title, triggerText, children, variant = 'icon', emphasis }) => {
  const trigger =
    variant === 'icon' ? (
      <StyledButton aria-label={triggerText}>
        <InfoIcon />
      </StyledButton>
    ) : (
      <TextLink emphasis={emphasis} rightIcon={<InfoIcon />}>
        {triggerText}
      </TextLink>
    );

  const isDesktop = useMediaQuery('lg');

  return (
    <Popover title={title || triggerText} side="bottom" size={isDesktop ? 'large' : 'small'} trigger={trigger}>
      {children}
    </Popover>
  );
};

export default InfoComponent;
